import styled from 'styled-components';
import { BKJDropdown } from '../BKJDropdown/index.js';
import { OnFocusInput } from '../common/index.js';
export const StyledTimeInputWrapper = styled.div `
  &:focus-within input {
    ${OnFocusInput()};
  }
`;
export const StyledDropdown = styled(BKJDropdown) `
  border: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
`;
//# sourceMappingURL=BKJTimeInput.styled.js.map